export const tipoDocumentoOptions: Values[] = [
  {
    label: "Nota Fiscal de Entrada",
    value: 0,
  },
  {
    label: "Nota Fiscal de Saída",
    value: 1,
  },
];

export const localDestinoOptions: Values[] = [
  {
    label: "Operação interna",
    value: 1,
  },
  {
    label: "Operação interestadual",
    value: 2,
  },
  {
    label: "Operação com exterior",
    value: 3,
  },
];

export const finalidadeEmissaoOptions: Values[] = [
  {
    label: "Normal",
    value: 1,
  },
  {
    label: "Complementar",
    value: 2,
  },
  {
    label: "Nota de ajuste",
    value: 3,
  },
  {
    label: "Devolução",
    value: 4,
  },
];

export const consumidorFinalOptions: Values[] = [
  {
    label: "Normal",
    value: 0,
  },
  {
    label: "Consumidor final",
    value: 1,
  },
];

export const presencaCompradorOptions: Values[] = [
  {
    label:
      "Não se aplica(por exemplo, para a Nota Fiscal complementar ou de ajuste)",
    value: 0,
  },
  {
    label: "Operação presencial",
    value: 1,
  },
  {
    label: "Operação não presencial, pela Internet",
    value: 2,
  },
  {
    label: "Operação não presencial, Teleatendimento",
    value: 3,
  },
  {
    label: "NFC - e em operação com entrega em domicílio",
    value: 4,
  },
  {
    label: "Operação não presencial, outros",
    value: 9,
  },
];

export const regimeTributarioEmitenteOptions: Values[] = [
  {
    label: "Simples Nacional",
    value: 1,
  },
  {
    label: "Simples Nacional – excesso de sublimite de receita bruta",
    value: 2,
  },
  {
    label: "Regime Normal",
    value: 3,
  },
];

export const indicadorIntermediarioOptions: Values[] = [
  {
    label: "Operação sem intermediador (em site ou plataforma própria)",
    value: 0,
  },
  {
    label:
      "Operação em site ou plataforma de terceiros (intermediadores/marketplace)",
    value: 1,
  },
];

export const naturezaOperacao: Values[] = [
  {
    value: 1,
    label: "Tributação no município",
  },
  {
    value: 2,
    label: "Tributação fora do município",
  },
  {
    value: 3,
    label: "Isenção",
  },
  {
    value: 4,
    label: "Imune",
  },
  {
    value: 5,
    label: "Exigibilidade suspensa por decisão judicial",
  },
  {
    value: 6,
    label: "Exigibilidade suspensa por procedimento administrativo",
  },
];

export interface Values {
  value: number | string;
  label: string;
}
